import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { formatPrice } from 'services/formatter';

import styles from './ProductCardPrice.module.scss';

type ProductPriceType = {
  price: string;
  hasUniqPrice?: boolean;
  discountPrice?: string;
  lotQuantity?: number;
  className?: string;
  classes?: {
    discount?: string;
    price?: string;
    priceFrom?: string;
  };
};

export default function ProductCardPrice({
  price,
  hasUniqPrice,
  discountPrice,
  lotQuantity,
  className,
  classes,
}: ProductPriceType): JSX.Element {
  const { t } = useTranslation();
  const hasDiscount = !!(discountPrice && parseFloat(discountPrice) > 0);

  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.fromDiscountContainer}>
        {!hasUniqPrice && (
          <span className={classNames(styles.from, classes?.priceFrom)}>
            {t('LABEL_FROM')}
          </span>
        )}
        {hasDiscount && (
          <span className={styles.discountPrice}>
            {formatPrice(discountPrice)}
          </span>
        )}
      </div>
      <RenderPrice
        price={price}
        hasDiscount={hasDiscount}
        lotQuantity={lotQuantity}
        classes={{ price: classes?.price }}
      />
    </div>
  );
}

function RenderPrice({
  price,
  hasDiscount,
  lotQuantity,
  classes,
}: {
  price: string;
  hasDiscount: boolean;
  lotQuantity?: number;
  classes?: {
    price?: string;
  };
}) {
  const { t } = useTranslation();

  if (lotQuantity) {
    return (
      <div className={styles.priceContainer}>
        <span
          className={classNames(styles.price, classes?.price, {
            [styles.highlight]: hasDiscount,
          })}
        >
          {formatPrice(price)}
        </span>
        &nbsp;
        <span className={styles.lotQuantity}>
          {t('PRODUCT_LOT', { number: lotQuantity })}
        </span>
      </div>
    );
  }

  return (
    <span
      className={classNames(styles.price, classes?.price, {
        [styles.highlight]: hasDiscount,
      })}
    >
      {formatPrice(price)}
    </span>
  );
}
